import ExchangeModal from "./ExchangeModal";

export default function PotionExchangeModal({
  open,
  potion,
  gems,
  gemCounts,
  onClose,
  onSuccess,
}) {
  return (
    <ExchangeModal
      open={open}
      item={potion}
      itemKind="potion"
      gems={gems}
      gemCounts={gemCounts}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
}
